import { React, useState } from "react";
import AdminHeader from "./AdminHeader";
import AdminSidebar from "./AdminSidebar";
import TimeFrequency from "./Settings/TimeFrequency";
import BatteryStatus from "./Settings/BatteryStatus";
import AlertSetting from "./Settings/AlertSetting";
import DeviceNotification from "./Settings/DeviceNotification";
import IconColor from "./Settings/IconColor";
import TimeZone from "./Settings/TimeZone";
const AdminSettings = ({ updateSidebar, isOpenSidebar }) => {
  const [pageTitle, setPageTitle] = useState("Settings");
  return (
    <>
      <div className="page-wrapper chiller-theme toggled">
        <AdminSidebar
          isOpenSidebar={isOpenSidebar}
          updateSidebar={updateSidebar}
        />
        <main className="page-content ">
          <AdminHeader pageTitle={pageTitle} isOpenSidebar={isOpenSidebar} />
          <main
            className={
              "content-holder " + (isOpenSidebar != true ? "show" : "")
            }
          >
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div className="main-wrapper">
                    <ul
                      className="nav nav-pills mb-3 "
                      id="pills-tab"
                      role="tablist"
                    >
                      <li className="nav-item me-2" role="presentation">
                        <button
                          className="nav-link active"
                          id="pills-timezone-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-timezone"
                          type="button"
                          role="tab"
                          aria-controls="pills-timezone"
                          aria-selected="true"
                        >
                          Time Zone
                        </button>
                      </li>
                      <li className="nav-item me-2" role="presentation">
                        <button
                          className="nav-link"
                          id="pills-timefeq-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-timefeq"
                          type="button"
                          role="tab"
                          aria-controls="pills-timefeq"
                          aria-selected="false"
                        >
                          Time Frequency
                        </button>
                      </li>

                      <li className="nav-item me-2" role="presentation">
                        <button
                          className="nav-link"
                          id="pills-alert-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-alert"
                          type="button"
                          role="tab"
                          aria-controls="pills-alert"
                          aria-selected="false"
                        >
                          Alerts Type
                        </button>
                      </li>
                      <li className="nav-item me-2" role="presentation">
                        <button
                          className="nav-link"
                          id="pills-alert-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-color"
                          type="button"
                          role="tab"
                          aria-controls="pills-color"
                          aria-selected="false"
                        >
                          Icon Color
                        </button>
                      </li>
                    </ul>
                    <div className="tab-content" id="pills-tabContent">
                      {/* Time Zone */}
                      <div
                        className="tab-pane fade show active"
                        id="pills-timezone"
                        role="tabpanel"
                        aria-labelledby="pills-timezone-tab"
                      >
                        <TimeZone />
                      </div>
                      <div
                        className="tab-pane fade  "
                        id="pills-timefeq"
                        role="tabpanel"
                        aria-labelledby="pills-timefeq-tab"
                      >
                        <TimeFrequency />
                      </div>

                      {/* Alert Setting */}
                      <div
                        className="tab-pane fade"
                        id="pills-alert"
                        role="tabpanel"
                        aria-labelledby="pills-alert-tab"
                      >
                        <AlertSetting />
                      </div>
                      {/* Color Setting */}
                      <div
                        className="tab-pane fade"
                        id="pills-color"
                        role="tabpanel"
                        aria-labelledby="pills-alert-tab"
                      >
                        <IconColor />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </main>
      </div>
    </>
  );
};
export default AdminSettings;
